module.exports = __webpack_public_path__ + "static/img/06_normal.414cf14f.jpg";